import { getLocale } from "../runtime";

const sv_waressingular = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `${inputs.value} vara`
};

const waressingular = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_waressingular(inputs)
	return "waresSingular";
};

export { waressingular as "waresSingular" };